import { bytesToString } from "@/utils/utils";
/**
 * Contains summary information about how much storage space can be recovered by removing
 * a collection of items from it.
 */
export class CleanableSummary {
    constructor(data) {
        Object.defineProperty(this, "_data", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        this._data = data;
    }
    /**
     * The total size in bytes that can be recovered by removing all the items.
     */
    get totalSize() {
        return this._data.total_size;
    }
    /**
     * The human readable total amount of disk space that can be recovered.
     */
    get niceTotalSize() {
        return bytesToString(this.totalSize, true, undefined);
    }
    /**
     * The total number of items that could be removed.
     */
    get totalItems() {
        return this._data.total_items;
    }
}
